import { createContext, useContext } from 'react';
import { jsx } from 'react/jsx-runtime';

const PrintContext = /*#__PURE__*/createContext(false);
function PrintContextProvider(props) {
  return /*#__PURE__*/jsx(PrintContext.Provider, {
    value: props.isPrinting,
    children: props.children
  });
}
function useIsPrintContent() {
  return useContext(PrintContext);
}

export { PrintContextProvider, useIsPrintContent };
//# sourceMappingURL=print-context.js.map
